import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { Payment } from "./Payment";
import { AmountFooter } from "./AmountFooter";

export const AmountPaid: React.FC<any> = React.memo((props) => {
  return (
    <Grid>
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} sm={5}>
          <Typography variant="body1" fontWeight={"bold"} color={"green"}>
            Amount Paid
          </Typography>
          <TableContainer component={Paper} sx={{ mt: 2, width: '30rem', height: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "lightgray" }}>
                  <TableCell align="left">Receipt#</TableCell>
                  <TableCell align="right">New Receipt</TableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "whitesmoke" }}>
                {[
                  { label: "Bill Amount", amount: "157.70" },
                  { label: "Gratuity Amount", amount: "0.00" },
                  { label: "Amount Paid", amount: "0.00" },
                  { label: "Amount Posted", amount: "0.00" },
                  { label: "Due Amount", amount: "157.70" },
                ].map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.label}</TableCell>
                    <TableCell align="right" sx={{ position: 'relative' }}>
                      {row.amount}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid container spacing={2} sx={{ mt: 4 }}>
          <Grid item xs={10} >
      <Grid
        sx={{
          border: "1px solid #ccc", // Border for the box
          height: "23rem",          // Height of the box
        }}
      >
        <Grid sx={{display:"flex",backgroundColor:"white", }}>
          <Typography padding={2}>
            Date
          </Typography>
          <Typography padding={2}>
            Description
          </Typography>
        </Grid>


        
      </Grid>
    </Grid>
    <Grid item xs={1}>
    <Grid
       sx={{
        height: '20rem', // Set the height of the scrollable area
        overflowY: 'auto', // Enable vertical scrolling
        border: '1px solid #ccc', // Optional: add a border for visibility
        backgroundColor: '#fafafa', // Optional: background color for better visibility
        '&::-webkit-scrollbar': {
          width: '8px', // Width of the scrollbar
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1', // Color of the scrollbar track
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888', // Color of the scrollbar thumb
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555', // Color of the scrollbar thumb on hover
        },
      }}
    >
      </Grid>
    </Grid>
    </Grid>
        </Grid>
        <Grid item xs={12} sm={7}>
      <Grid sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <WSIcons.CloseIcon sx={{ backgroundColor: "red" }} />
      </Grid>

      {/* Payment component will keep its default alignment */}
      <Grid item>
        <Payment />
      </Grid>
    </Grid>
      </Grid>
      <Grid item xs={12}>
      <AmountFooter/>

      </Grid>
    </Grid>
  );
});
